import { render, staticRenderFns } from "./DocumentTemplateListToolbar.vue?vue&type=template&id=537ee475&"
import script from "./DocumentTemplateListToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports